module.exports = __webpack_public_path__ + "img/user (1).619d39f3.png";